import { graphql } from "../gql";

export const getUniqueProcedureCodesQueryDoc = graphql(`
  query getUniqueProcedureCodes($includes: String!) {
    uniqueProcedureCodes(filter: { includes: $includes }) {
      nodes
    }
  }
`);
